<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-h"><b>CONTENTS</b></p>
<table>
<tbody><tr>
<td></td>
<td><p class="tocentry-2"><a href="#/xhtml/introduction">Introduction</a></p></td>
</tr>
<tr>
<td><p class="tocentry"><a href="#/xhtml/part1"><span class="smallcaps">PART ONE</span></a></p></td>
<td><p class="tocentry"><a href="#/xhtml/part1">The Desert</a></p></td>
</tr>
<tr>
<td><p class="tocentry"><a href="#/xhtml/part2"><span class="smallcaps">PART TWO</span></a></p></td>
<td><p class="tocentry"><a href="#/xhtml/part2">The Land</a></p></td>
</tr>
<tr>
<td><p class="tocentry"><a href="#/xhtml/part3"><span class="smallcaps">PART THREE</span></a></p></td>
<td><p class="tocentry"><a href="#/xhtml/part3">The Kings and the Prophets</a></p></td>
</tr>
<tr>
<td><p class="tocentry"><span href="#/xhtml/part4" title="Link target outside of Sample"><span class="smallcaps">PART FOUR</span></span></p></td>
<td><p class="tocentry"><span href="#/xhtml/part4" title="Link target outside of Sample">The Exile</span></p></td>
</tr>
<tr>
<td><p class="tocentry"><span href="#/xhtml/part5" title="Link target outside of Sample"><span class="smallcaps">PART FIVE</span></span></p></td>
<td><p class="tocentry"><span href="#/xhtml/part5" title="Link target outside of Sample">Herod and Hillel</span></p></td>
</tr>
<tr>
<td><p class="tocentry"><span href="#/xhtml/part6" title="Link target outside of Sample"><span class="smallcaps">PART SIX</span></span></p></td>
<td><p class="tocentry"><span href="#/xhtml/part6" title="Link target outside of Sample">Jesus and Christianity</span></p></td>
</tr>
<tr>
<td><p class="tocentry"><span href="#/xhtml/part7" title="Link target outside of Sample"><span class="smallcaps">PART SEVEN</span></span></p></td>
<td><p class="tocentry"><span href="#/xhtml/part7" title="Link target outside of Sample">The Diaspora</span></p></td>
</tr>
<tr>
<td><p class="tocentry"><span href="#/xhtml/part8" title="Link target outside of Sample"><span class="smallcaps">PART EIGHT</span></span></p></td>
<td><p class="tocentry"><span href="#/xhtml/part8" title="Link target outside of Sample">The Wandering Jew</span></p></td>
</tr>
<tr>
<td><p class="tocentry"><span href="#/xhtml/part9" title="Link target outside of Sample"><span class="smallcaps">PART NINE</span></span></p></td>
<td><p class="tocentry"><span href="#/xhtml/part9" title="Link target outside of Sample">Into Europe and North</span></p></td>
</tr>
<tr>
<td><p class="tocentry"><span href="#/xhtml/part10" title="Link target outside of Sample"><span class="smallcaps">PART TEN</span></span></p></td>
<td><p class="tocentry"><span href="#/xhtml/part10" title="Link target outside of Sample">They Discover America</span></p></td>
</tr>
<tr>
<td><p class="tocentry"><span href="#/xhtml/part11" title="Link target outside of Sample"><span class="smallcaps">PART ELEVEN</span></span></p></td>
<td><p class="tocentry"><span href="#/xhtml/part11" title="Link target outside of Sample">The Holocaust</span></p></td>
</tr>
<tr>
<td></td>
<td><p class="tocentry-1"><a href="#/xhtml/bibliographicalnote">Bibliographical Note</a></p></td>
</tr>
<tr>
<td></td>
<td><p class="tocentry"><span href="#/xhtml/Afterword" title="Link target outside of Sample">Afterword</span></p></td>
</tr>
<tr>
<td></td>
<td><p class="tocentry"><span href="#/xhtml/bibliography" title="Link target outside of Sample">Bibliography</span></p></td>
</tr>
<tr>
<td></td>
<td><p class="tocentry"><span href="#/xhtml/images" title="Link target outside of Sample">Image Gallery</span></p></td>
</tr>
<tr>
<td></td>
<td><p class="tocentry"><span href="#/xhtml/biography" title="Link target outside of Sample">A Biography of Howard Fast</span></p></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?55b65422